import * as Sentry from "@sentry/react";

// Sentry must be initialised before any other React code so that errors
// raised during early renders / module side-effects are still captured.
// A missing DSN simply disables the SDK (it becomes a no-op).
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  const tracesRaw = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE;
  const tracesSampleRate = tracesRaw ? Number(tracesRaw) : 0.1;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    sampleRate: 1.0,
    tracesSampleRate,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Only propagate trace headers to our own backend.
    tracePropagationTargets: [
      /^\/api\//,
      /uptopapp\.com/,
      /preview\.emergentagent\.com/,
    ],
  });
}
